<template>
  <div>
    <template v-if="introScreen">
      <div class="bg-intro">
        <div class="container-fluid">
          <div class="top-navigation">
            <div class="row">
              <div class="col-4"></div>
              <div class="col-4"></div>
              <div class="col-4 logo navigation-wrapper text-right">
                <img src="../../assets/img/ngkids-photo_ark.png">
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid fixed-bottom">
          <div class="row">
            <div class="col-4">
              <div class="loading">
                <img src="../../assets/img/loading.gif"/>
              </div>
            </div>
            <div class="col-4 loading-text-wrapper">
            </div>
            <div class="col-4 logo">
              <img src="../../assets/img/logo.png">
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="!introScreen">
      <div v-if="start" class="bg">
        <top-navigation class="top-navigation" v-show="!end" :show-back="false" :in-game="true">
          <div slot="left">
            <span class="orange timer">{{ timeDiffText }}</span>
          </div>
          <div slot="middle" class="score">
            {{ found }} <span class="orange">/ {{ totalLoaded }}</span>
          </div>
          <div slot="right" class="logo">
            <img src="../../assets/img/ngkids-photo_ark.png">
          </div>
        </top-navigation>
        <div v-if="!end" class="animals-wrapper">
          <div class="animals-row" :key="row" v-for="(chunk, row) in loadedAnimals">
            <div class="animal" :class="{ flipped: animal.flipped }" :key="row + '_' + col" v-for="(animal, col) in chunk" @click="flip(animal, row, col)">
              <div class="animal-inner" :class="{ hidden: animal.hidden }">
                <div class="animal-front">
                </div>
                <div class="animal-back">
                  <img :src="animal.thumbnail"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <game-description :show-logo="false" :show-photo-ark="true" v-else @start="startGame()" title="NOW YOU SEE ME" description="Flip the cards to find the matching animals!" bg="now-you-see-me"></game-description>
    </template>
  </div>
</template>

<script>
import TopNavigation from '../../components/TopNavigation'
import GameDescription from '../../components/GameDescription'
import moment from 'moment'
import shuffle from 'shuffle-array'
import { mapGetters, mapActions, mapMutations } from 'vuex'

let timer
export default {
  name: 'NowYouSeeMe',
  components: {
    GameDescription,
    TopNavigation
  },
  data () {
    return {
      end: false,
      start: false,
      timeDiff: null,
      timeDiffText: '2:00',
      found: 0,
      chances: 40,
      loadedAnimals: [],
      flipped: 0,
      flippedIds: {
        first: { index: null, ID: null },
        second: { index: null, ID: null }
      },
      gameScore: 0,
      introScreen: true,
      totalLoaded: 0
    }
  },
  mounted () {
    setTimeout(() => {
      this.introScreen = false
    }, 3000)
  },
  methods: {
    startGame () {
      const animals = shuffle(this.animals).slice(0, 6)
      const allAnimalsArray = shuffle(animals.concat(animals).map((animal, index) => {
        animal.index = index
        animal.hidden = false
        animal.flipped = false
        return Object.assign({}, animal)
      }))
      while (allAnimalsArray.length > 0) {
        this.loadedAnimals.push(shuffle(allAnimalsArray.splice(0, 4)))
      }
      this.totalLoaded = animals.length
      this.start = true
      let end = moment().add(2, 'minutes')
      timer = setInterval(() => {
        this.timeDiff = end.diff(moment())
        this.timeDiffText = moment(this.timeDiff).format('m:ss')
        if (this.timeDiff <= 0) {
          this.timeDiffText = '0:00'
          this.endGame()
          clearInterval(timer)
        }
      }, 500)
    },
    flip (animal, row) {
      if (this.flipped !== 2) {
        if (this.flipped < 2) {
          if (animal.flipped === false && animal.hidden === false) {
            this.$set(this.loadedAnimals, row, this.loadedAnimals[row].map(a => {
              if (a.index === animal.index) {
                a.flipped = true
                if (this.flipped === 0) {
                  this.flippedIds.first.ID = a.ID
                  this.flippedIds.first.index = a.index
                  if (this.flippedIds.first.index !== this.flippedIds.second.index) {
                    this.flipped++
                  }
                }
                if (this.flipped === 1) {
                  this.flippedIds.second.ID = a.ID
                  this.flippedIds.second.index = a.index
                  if (this.flippedIds.first.index !== this.flippedIds.second.index) {
                    this.flipped++
                  }
                }
              }
              return a
            }))
          }
        }
        if (this.flipped === 2) {
          this.chances--
          setTimeout(() => {
            if (this.flippedIds.first.ID === this.flippedIds.second.ID && this.flippedIds.first.ID !== null && this.flippedIds.second.ID !== null) { // score
              this.found++
              this.gameScore += 1000
              for (let i = 0; i < 3; i++) {
                this.$set(this.loadedAnimals, i, this.loadedAnimals[i].map(a => {
                  if (a.ID === this.flippedIds.first.ID) {
                    a.hidden = true
                  }
                  return a
                }))
              }
            } else { // hide cards
              for (let i = 0; i < 3; i++) {
                this.$set(this.loadedAnimals, i, this.loadedAnimals[i].map(a => {
                  if (a.index === this.flippedIds.first.index) {
                    a.flipped = false
                  }
                  if (a.index === this.flippedIds.second.index) {
                    a.flipped = false
                  }
                  return a
                }))
              }
            }
            this.flippedIds.second = { index: null, ID: null }
            this.flippedIds.first = { index: null, ID: null }
            this.flipped = 0
          }, 1000)
        }
      }
    },
    endGame () {
      if (this.chances > 20 && this.found === 6) {
        this.gameScore += 2000
      }
      this.addToScore(this.gameScore)
      clearInterval(timer)
      this.end = true
      this.setLastGameScore(this.gameScore)
      this.$router.push({ name: 'GameScore' })
    },
    ...mapActions(['addToScore', 'cardsUnlock']),
    ...mapMutations(['setLastGameScore'])
  },
  computed: {
    ...mapGetters(['animals'])
  },
  watch: {
    found (found) {
      if (found === 3 || found === 6) {
        this.cardsUnlock('nowYouSeeMe')
      }
      if (found === 6) {
        this.endGame()
      }
    },
    chances (chances) {
      if (chances === 0) {
        this.endGame()
      }
    }
  },
  beforeDestroy () {
    clearInterval(timer)
  }
}
</script>

<style scoped>
  .bg-intro {
    width: 100%;
    height: 100%;
    background-image: url("../../assets/img/now-you-see-me-intro.jpg");
    background-size: cover;
    background-position: left;
  }

  .bg {
    width: 100%;
    height: 100%;
    background-image: url("../../assets/img/now-you-see-me-description-bg.jpg");
    background-size: cover;
    background-position: center;
  }

  .score {
    color: #ffffff;
    font-size: 3vw;
    font-family: 'Geograph-Bold';
  }

  .timer {
    font-family: 'Geograph-Black';
    float: left;
    font-size: 3vw;
    margin-left: 10px;
    display: inline-block;
    vertical-align: middle;
  }

  .animals-row {
    float: left;
  }

  .animals-wrapper {
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    width: 100vh;
  }

  .animal-inner {
    opacity: 1;
  }

  .animal-inner.hidden {
    opacity: 0;
    transition: opacity 500ms ease-in-out;
  }

  .animal {
    perspective: 1000px;
    float: left;
    background-color: transparent;
    height: calc(70vh / 3);
    width: calc(70vh / 3);
    margin-left: 1vh;
    margin-bottom: 1vh;
  }

  .animal-inner img {
    width: 100%;
  }

  .animal-back {
    border: 0.5vw solid #ffbf00;
    background: linear-gradient(to left top, #509858 5%, #6ea93f 100%);
    text-align: center;
    overflow: hidden;
    transform: rotateY(180deg);
    width: 100%;
    height: calc(70vh / 3);
  }

  .animal-front {
    border: 0.5vw solid #ffbf00;
    background: linear-gradient(to left top, #509858 5%, #6ea93f 100%);
    text-align: center;
    overflow: hidden;
    width: 100%;
    height: calc(70vh / 3);
  }

  .animal.flipped .animal-inner {
    transform: rotateY(180deg);
  }

  .animal-inner {
    transition: transform 1s;
    transform-style: preserve-3d;
  }

  .animal-front, .animal-back {
    position: absolute;
    backface-visibility: hidden;
  }

  .loading img {
    height: 10vh;
  }
</style>
